import * as React from 'react';
import {resolveVanSizeTier, VAN_BASE_IMAGE} from './VanBySize';

const FRAME_INTERVAL_MS = 1600;

type AnimatedVanProps = {
    selectedSize: string;
};

// Cycles base -> schema -> filled-to-size, then loops back to base. All frames
// stay mounted and stacked on top of each other the whole time — only opacity
// changes — so the crossfade is a plain CSS transition between two already
// -decoded images instead of swapping `src`/remounting, which is what caused
// the blink (browser had to reload+redecode the image on every tick).
export const AnimatedVan = ({selectedSize}: AnimatedVanProps) => {
    const tier = resolveVanSizeTier(selectedSize);
    const frames = tier ? [VAN_BASE_IMAGE, tier.schema, tier.van] : [VAN_BASE_IMAGE];
    const [frameIndex, setFrameIndex] = React.useState(0);

    React.useEffect(() => {
        setFrameIndex(0);

        if (frames.length <= 1) {
            return;
        }

        const interval = setInterval(() => {
            setFrameIndex((prev) => (prev + 1) % frames.length);
        }, FRAME_INTERVAL_MS);

        return () => clearInterval(interval);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tier?.size]);

    return (
        <div className="van-frame-stack">
            {frames.map((src, index) => (
                <img
                    key={src}
                    src={src}
                    alt="Mikroautobusas"
                    className={`van-frame${index === frameIndex ? ' van-frame-visible' : ''}`}
                />
            ))}
        </div>
    );
};
